import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const WelcomeModal = () => {
  // Estado para manejar si el modal debe mostrarse
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Mostrar el modal siempre que la página sea recargada
    const isPageReload = performance.getEntriesByType('navigation')[0]?.type === 'reload';

    // Mostrar si es una recarga o si no se ha mostrado antes en esta sesión
    if (!sessionStorage.getItem('hasVisited') || isPageReload) {
      setShow(true);
      sessionStorage.setItem('hasVisited', true); // Marcar la sesión como visitada
    }
  }, []); // Ejecuta esto solo una vez al cargar el componente

  const handleClose = () => setShow(false); // Cierra el modal

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>¡Bienvenido!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>¡Nos alegra verte en nuestra página! Aquí encontrarás toda la información que necesitas sobre nuestro municipio.</p>
        <img 
          src={`${process.env.PUBLIC_URL}/logo2.jpg`} 
          alt="Bienvenida" 
          style={{ width: '100%' }} 
        />
        <p>¡Disfruta tu visita y no dudes en explorar nuestras secciones!</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WelcomeModal;
